import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    padding: theme.spacing(4, 2, 2, 2),
    color: theme.palette.text.secondary,
  },
  newPaper: {
    backgroundColor: "inherit",
    color: theme.palette.text.secondary,
    boxShadow: "none",
  },
  hover: {
    cursor: "pointer",
  },
  header: {
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(3),
  },
  newFlex: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
  },
  flex: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "5px",
  },
  dragAndDrop: {
    display: "inline-blok",
    opacity: 0,
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 50,
  },
  actionsButton: {
    height: "3rem",
  },
  textRight: {
    textAlign: "right",
  },
  clearButton: {
    backgroundColor: "transparent",
    color: "black",
    boxShadow: "none",
    right: "2%",
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
  input: {
    "&::placeholder": {
      color: "black",
    },
  },
  textField: {
    minWidth: "350px",
    backgroundColor: "white",
    [theme.breakpoints.up("lg")]: {
      minWidth: "375px",
    },
    "& .MuiOutlinedInput-root .MuiInputBase-input": {},
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      top: "0",
      borderRadius: "8px",
      borderColor: "#d8d8d8",
    },
    "& .MuiOutlinedInput-adornedEnd": {
      color: theme.palette.common.black,
      padding: 0,
    },
  },
  searchButtom: {
    borderRadius: "0 5px 5px 0",
    padding: "0 30px",
    backgroundColor: "#e5f2ff",
    color: "#0872fe",
    "&:hover": {
      backgroundColor: "#e5f2ff",
      color: "#0872fe",
      opacity: "80%",
    },
  },
  adormentColor: {
    color: theme.palette.common.black,
  },
}));
